import { render } from "./CutoverNoticeModal.vue?vue&type=template&id=40e8c8d4&scoped=true"
import script from "./CutoverNoticeModal.vue?vue&type=script&lang=js"
export * from "./CutoverNoticeModal.vue?vue&type=script&lang=js"

import "./CutoverNoticeModal.vue?vue&type=style&index=0&id=40e8c8d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e8c8d4"]])

export default __exports__